module.exports = __webpack_public_path__ + "static/media/File.a29572c3.svg";